export default {
  component: () => import('./page.vue'),
  name: 'subscribe',
  meta: {
    title: '周报订阅',
    auth: true,
  },
};
